import React from 'react';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useNearbyProjectsEvents from '../../opportunities/Recommended/useNearbyProjectsEvents';
import Redirect from '../../../components/Redirect';

export default function Layout(props) {
  const opportunities = useNearbyProjectsEvents();

  if (opportunities.state === PayloadStates.FETCHING) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Partner Value</title>
        </Helmet>
        <Loader />
      </ParentLayout>
    );
  }

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Partner Value</title>
      </Helmet>
      {opportunities.meta.totalCount >= 1 ? (
        <Redirect
          to={Urls.PARTNER_VALUE_YES}
          replace={true}
        />
      ) : (
        <Redirect
          to={Urls.PARTNER_VALUE_NO}
          replace={true}
        />
      )}
    </ParentLayout>
  );
};
